import type {
  Filter,
  TQueryOrderArray,
  TQueryOrderObject,
} from '@cubejs-client/core'

import { DDSPaginationState, TableStateChange } from '@driftt/dds'
import { CubeQuery } from '@driftt/dds.reports'

import { OpportunitiesTableRow } from 'layouts/RevenueReport'

export interface OpportunitiesContextType {
  startDate: Date
  endDate: Date
  filters: Filter[]
  order: TQueryOrderObject | TQueryOrderArray
}

export enum StageStatus {
  CLOSED_WON = 'Closed Won',
  CLOSED_LOST = 'Closed Lost',
  // NOTE: Anything that is not closed won or closed lost is in Pipeline
}

export interface IOpportunitiesTableDataResult {
  data: OpportunitiesTableRow[]
  totalRowCount: number | undefined
  isLoading: boolean
  isError: boolean
  isLoadingOpportunityCount: boolean
  isErrorTotaOpportunityCount: boolean
  pagination: DDSPaginationState
  getOpportunityDataCubeQuery: CubeQuery
  handleTableStateChange: (
    newState: TableStateChange<OpportunitiesTableRow>
  ) => void
}
